"use client";

import React from "react";
import { Heading, Modal, Text, Button, TextButton } from "ui-components";

import { useMessageDeleteConversation } from "@/src/hooks/api/generated";
import { useChat } from "@/src/hooks/useChat";
import { useChatFunctions } from "@/src/hooks/useChatFunctions";

import { makeToast } from "../Toast/Toast";

export interface IDeleteConversationConfirmationModalProps {
  conversationId?: number;
  isOpen?: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export function DeleteConversationConfirmationModal({
  conversationId,
  isOpen,
  onOpenChange,
}: IDeleteConversationConfirmationModalProps): JSX.Element {
  const { selectedConversation } = useChat();
  const { deleteConversationBaseOnId } = useChatFunctions();

  const { mutate: deleteConversation, status: deletingConversationStatus } =
    useMessageDeleteConversation();

  const handleDeleteConversationPress = (): void => {
    const payload = {
      conversationId: conversationId || selectedConversation?.conversationId,
    };
    if (payload && payload.conversationId) {
      deleteConversation(
        { conversationId: payload.conversationId.toString() },
        {
          onSuccess: () => {
            makeToast({
              intent: "success",
              title: "Conversation Deleted Successfully.",
            });
            onOpenChange(false);
            if (payload && payload.conversationId) {
              deleteConversationBaseOnId(payload.conversationId);
            }
          },
          onError: () => {
            makeToast({
              intent: "danger",
              title: "Something went wrong",
            });
            onOpenChange(false);
          },
        }
      );
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(value) => onOpenChange(value)}
      closeIcons
      isDismissable
    >
      <div className="flex flex-col flex-1 items-center justify-start gap-10 pt-5">
        <Heading align="center">Delete conversation</Heading>
        <Text align="center">
          Are you sure you would like to delete this conversation?
        </Text>
        <div className="flex flex-col flex-1 items-center justify-start gap-4">
          <Button
            onClick={handleDeleteConversationPress}
            isLoading={deletingConversationStatus === "pending"}
            isDisabled={deletingConversationStatus === "pending"}
          >
            <Text>Delete Conversation</Text>
          </Button>
          <TextButton underLine onPress={() => onOpenChange(false)}>
            Cancel
          </TextButton>
        </div>
      </div>
    </Modal>
  );
}
